import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { contextErrorLinks, retryLink, batchingLink } from '@opendoor/shared-fe/build/apolloLink';
import * as Datadog from './utils/datadog';
import { ErrorResponse, onError } from '@apollo/client/link/error';

Datadog.init();

const setBetterErrorMessageOnParsingError = (networkError: ErrorResponse['networkError']) => {
  // when the response cannot be parsed (a ServerParseError e.g., due to HTML)
  // set the error message to the HTML text for possibly a better sentry error
  if (networkError && 'bodyText' in networkError) {
    networkError.message = networkError.bodyText;
  }
};

const errorLink = onError(({ networkError }) => {
  setBetterErrorMessageOnParsingError(networkError);
});

export const clientFromUrl = (uri: string = '/api/graphql'): ApolloClient<NormalizedCacheObject> =>
  new ApolloClient({
    name: 'trade-partner-portal',
    version: '1.0',
    link: ApolloLink.from([...contextErrorLinks({}), retryLink({}), errorLink, batchingLink(uri)]),
    cache: new InMemoryCache({
      typePolicies: {
        OdProtosVendorsServices_Vendor_Query: {
          keyFields: [],
        },
      },
    }),
  });
